import * as TFF from '@tff/types/tff';

/**
 * Checks if refund checks should be skipped during cancellation
 * Skips for:
 * - NSK bookings (NSK, TUI-NSK)
 * - NDC-X Finnair (AY) non-ticketed bookings
 */
export const shouldSkipRefundCheck = (
  flightDetails: TFF.FlightDetails,
  bookingSource: TFF.TffBookingSource,
): boolean => {
  if (['NSK', 'TUI-NSK'].includes(bookingSource)) return true;

  if (bookingSource === 'TUI-NDCX') {
    if (flightDetails.OrderSummary?.DesignatedAirlineCode !== 'AY') return false;

    const ticketNumbers = flightDetails.OrderSummary?.PaxTicketNumbers;
    return !ticketNumbers || Object.keys(ticketNumbers).length === 0;
  }

  return false;
};
